import React, { ChangeEventHandler } from "react";
import { Lock } from "@material-ui/icons";
import { Switch, Tooltip } from "@material-ui/core";
import makeStyles from "@material-ui/styles/makeStyles";

import AvatarCard from "../../../../../components/AvatarCard";

interface Props {
  values: {
    restricted: boolean;
  };
  handleChange: ChangeEventHandler<HTMLInputElement>;
  handleBlur: ChangeEventHandler<HTMLInputElement>;
  disabled: boolean;
  classes: { [key: string]: string };
}

const useStyles = makeStyles(() => ({
  toggleMovedToLeft: {
    marginLeft: -15,
  }
}));

const RestrictedCard = ({
  values,
  handleChange,
  handleBlur,
  disabled
}: Props): JSX.Element => {
  const classes = useStyles();

  return (
    <AvatarCard
      title="Restricted"
      color={values.restricted ? "#d0021b" : "#4dc527"}
      disabled={disabled}
      icon={<Lock style={{ fontSize: "32px" }} />}
      subheader={
        <Tooltip title="When enabled, this debtor will not appear in search results for clients who are not already connected to it.">
          <Switch
            disabled={disabled}
            name="restricted"
            checked={values.restricted}
            onChange={handleChange}
            onBlur={handleBlur}
            style={{height: "unset"}}
            className={classes.toggleMovedToLeft}
          />
        </Tooltip>
      }
    />
  )
};

// @ts-ignore
export default RestrictedCard;
